import type { Hub } from '../../../lib/api-types';

/** Nothing live, scheduled or in the library: the hub leaves the mock cards out. */
export function noMocksYet(hub: Pick<Hub, 'live' | 'nextLive' | 'library'>): boolean {
  return !hub.live && !hub.nextLive && hub.library.length === 0;
}

/** What the hub shows in the mock slot: nothing while switched off, a friendly empty card, or the mock cards. */
export function mockSlot(
  hub: Pick<Hub, 'mocksEnabled' | 'live' | 'nextLive' | 'library'>,
): 'off' | 'empty' | 'cards' {
  if (!hub.mocksEnabled) return 'off';
  return noMocksYet(hub) ? 'empty' : 'cards';
}
